import React from 'react';
import { IconType } from 'components/Icon/constants';
import { TitleWithNamespace as Title } from 'components/Toolbar/constants';
import { ScriptType } from 'const';
import EditorToolbarButton from '../EditorToolbarButton';
import styles from './styles.module.scss';

export const SCRIPT_CONTROLS = [
  {
    label: IconType.TOOLBAR_SUPERSCRIPT,
    style: ScriptType.SUPERSCRIPT,
    title: Title.FONT_SUPERSCRIPT,
  },
  {
    label: IconType.TOOLBAR_SUBSCRIPT,
    style: ScriptType.SUBSCRIPT,
    title: Title.FONT_SUBSCRIPT,
  },
];

type Props = {
  type: ScriptType | undefined;
  onToggle: (style: ScriptType) => void;
  dataTestId?: string;
};

const ScriptControl: React.FunctionComponent<Props> = ({ type, onToggle, dataTestId = 'scriptControl' }) => (
  <div className={styles.ScriptControl} data-testid={dataTestId}>
    {SCRIPT_CONTROLS.map((control, index) => (
      <EditorToolbarButton
        key={control.label}
        active={type === control.style}
        label={control.label}
        onToggle={onToggle}
        value={control.style}
        title={control.title}
        dataTestId={`${dataTestId}-editorToolbarButton${index}`}
      />
    ))}
  </div>
);

export default ScriptControl;
